import { useMutation } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { GET, GET_CLAIM_DETAIL } from '../../../../services';
import { applyClaimMobilesDisplayToFormValues } from '../../../../functions/claimMobilesDisplay';

export const useGetClaimEdit = ({ claimCode, reset, getValues }) => {
  const [data, setData] = useState();

  const { isPending, mutate } = useMutation({
    mutationFn: async () => {
      const response = await GET(GET_CLAIM_DETAIL(claimCode));
      return response.result;
    },
    onSuccess: (result) => {
      const claim = result?.claim;
      reset({
        ...getValues(),
        ...claim,
        ...applyClaimMobilesDisplayToFormValues(claim),
        claimImageUrl: [{ uid: claim?.claimImageUrl, url: claim?.claimImageUrl }],
        receiptImageUrl: [{ uid: claim?.receiptImageUrl, url: claim?.receiptImageUrl }],
      });
      setData(result);
    },
  });

  useEffect(() => {
    if (claimCode) {
      mutate();
    }
  }, [claimCode]);

  return { dataSource: data, loading: isPending };
};
